import type {
  BlocksFormData,
  JSONSchema,
  Brain,
  BlockConfigBase,
} from '@plone/types';
import { type IntlShape, defineMessages } from 'react-intl';
import addBlocksFullWidth from '../extenders/addBlocksFullWidth';
import addBlocksBg from '../extenders/addBlocksBg';
import addBlockLines from '../extenders/addBlockLines';

export interface BlogMacroSlide {
  // image: Brain; TODO: restore this as image saved in macrocategory ct + change name of field
  img: string; // TODO: remove this line
  title: string;
  tags: string[];
  '@id': string;
}

export interface BlogMacroGalleryData extends JSONSchema, BlocksFormData {
  '@type': 'blogMacrocategoriesGallery';
  styles: {
    fullwidth: boolean;
  };
}

const BlogMacroGallerySchema = ({
  data,
  intl,
}: {
  data: BlogMacroGalleryData;
  intl: IntlShape;
}): JSONSchema => {
  const schema = {
    title: 'Blog Macrocategories Gallery',
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: [],
      },
    ],
    properties: {},
    required: [],
  };
  addBlocksFullWidth({ schema, formData: data, intl });
  addBlocksBg({ schema, formData: data, intl });
  addBlockLines({ schema, formData: data, intl });
  return schema;
};

export default BlogMacroGallerySchema;

export interface BlogMacroGalleryConfig
  extends Omit<BlockConfigBase, 'blockSchema'> {
  blockSchema: typeof BlogMacroGallerySchema;
}

const messages = defineMessages({
  Slides: { id: 'Slides', defaultMessage: 'Slides' },
  Slide: { id: 'Slide', defaultMessage: 'Slide' },
  category: { id: 'category', defaultMessage: 'Category' },
});
